import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../redux/slices/usersApiSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../../redux/slices/authSlice";
import {
  IoEyeOutline,
  IoEyeOffOutline,
  IoMailOutline,
  IoLockClosedOutline,
  IoArrowForwardOutline,
  IoAlertCircleOutline,
  IoCheckmarkCircleOutline,
  IoRefreshOutline,
} from "react-icons/io5";

const Login = () => {
  const [email, setEmail] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [password, setPassword] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [validationMessage, setValidationMessage] = useState("");

  const navigation = useNavigate();
  const dispatch = useDispatch();

  const { userInfo } = useSelector((state) => state.auth);

  const [login, { isLoading }] = useLoginMutation();

  useEffect(() => {
    if (userInfo) {
      navigation("/");
    }
  }, [navigation, userInfo]);

  // ============================================================
  // XƏTA MESAJINI OXUNAQLI ŞƏKİLDƏ HAZIRLAYIR
  // ============================================================
  const getErrorMessage = (error) => {
    if (!error) {
      return "Naməlum xəta baş verdi. Zəhmət olmasa, yenidən cəhd edin.";
    }

    const serverMessage =
      error?.data?.message ||
      error?.data?.error ||
      error?.data?.data?.message ||
      error?.response?.data?.message ||
      error?.response?.data?.error;

    if (serverMessage) {
      return String(serverMessage);
    }

    const status = error?.status || error?.response?.status;

    if (status === 400) {
      return "Göndərilən məlumatlar düzgün deyil. E-poçt ünvanınızı, dəvət kodunuzu və şifrənizi yoxlayın.";
    }

    if (status === 401) {
      return "E-poçt ünvanı, dəvət kodu və ya şifrə düzgün deyil.";
    }

    if (status === 403) {
      return "Bu hesaba giriş üçün icazəniz yoxdur.";
    }

    if (status === 404) {
      return "İstifadəçi hesabı tapılmadı.";
    }

    if (status === 409) {
      return "Bu məlumatlarla bağlı ziddiyyət yarandı. Zəhmət olmasa, məlumatları yenidən yoxlayın.";
    }

    if (status === 429) {
      return "Çox sayda giriş cəhdi edildi. Zəhmət olmasa, bir qədər gözləyib yenidən cəhd edin.";
    }

    if (status >= 500) {
      return "Serverdə texniki problem baş verdi. Zəhmət olmasa, bir qədər sonra yenidən cəhd edin.";
    }

    if (
      error?.name === "TypeError" ||
      error?.message?.toLowerCase?.().includes("network")
    ) {
      return "Serverə qoşulmaq mümkün olmadı. İnternet bağlantınızı yoxlayın.";
    }

    if (error?.message) {
      return String(error.message);
    }

    return "Giriş zamanı gözlənilməz xəta baş verdi. Zəhmət olmasa, yenidən cəhd edin.";
  };

  // ============================================================
  // GİRİŞ
  // ============================================================
  const handleLogin = async (e) => {
    e.preventDefault();

    setErrorMessage("");
    setSuccessMessage("");
    setValidationMessage("");

    const loginValue = email.trim();

    if (!loginValue) {
      setValidationMessage(
        "Zəhmət olmasa, e-poçt ünvanınızı və ya dəvət kodunuzu daxil edin."
      );
      return;
    }

    if (!password) {
      setValidationMessage("Zəhmət olmasa, şifrənizi daxil edin.");
      return;
    }

  

    // Mövcud backend məntiqini qoruyuruq.
    // İstifadəçinin yazdığı məlumat həm email,
    // həm də referralCode olaraq göndərilir.
    const loginData = {
      email: loginValue,
      password,
      referralCode: loginValue,
    };

    try {
      const res = await login(loginData).unwrap();

      dispatch(setCredentials({ ...res }));

      setSuccessMessage("Giriş uğurla tamamlandı. Hesabınıza yönləndirilirsiniz...");

      setTimeout(() => {
        navigation("/");
      }, 700);
    } catch (error) {
      const message = getErrorMessage(error);

      setErrorMessage(message);
    }
  };

  const handleRegister = () => {
    if (isLoading) return;

    setErrorMessage("");
    setValidationMessage("");
    navigation("/register");
  };

  const handleHome = () => {
    if (isLoading) return;

    setErrorMessage("");
    setValidationMessage("");
    navigation("/");
  };

  return (
    <section className="relative min-h-screen overflow-hidden bg-slate-950 px-4 py-8 font-sans text-white sm:px-6">
      {/* ============================================================
          ARXA PLAN
      ============================================================ */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-32 -top-32 h-96 w-96 rounded-full bg-indigo-600/20 blur-3xl" />
        <div className="absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-violet-600/20 blur-3xl" />
        <div className="absolute left-1/2 top-1/2 h-80 w-80 -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue-600/10 blur-3xl" />

        <div
          className="absolute inset-0 opacity-[0.035]"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.8) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.8) 1px, transparent 1px)",
            backgroundSize: "40px 40px",
          }}
        />
      </div>

      {/* ============================================================
          ƏSAS KONTEYNER
      ============================================================ */}
      <div className="relative z-10 flex min-h-[calc(100vh-64px)] items-center justify-center">
        <div className="w-full max-w-md">
          {/* ========================================================
              LOGIN KARTI
          ======================================================== */}
          <div className="overflow-hidden rounded-[28px] border border-white/10 bg-slate-900/80 shadow-2xl shadow-indigo-950/40 backdrop-blur-xl">
            {/* ÜST HİSSƏ */}
            <div className="relative px-6 pb-6 pt-8 text-center sm:px-8 sm:pt-10">
              <div className="absolute left-0 right-0 top-0 h-px bg-gradient-to-r from-transparent via-indigo-500 to-transparent" />

              {/* LOGO */}
              <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl border border-indigo-400/20 bg-gradient-to-br from-indigo-500/20 to-violet-500/20 shadow-lg shadow-indigo-500/10">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 to-violet-600 text-xl font-black shadow-lg shadow-indigo-500/30">
                  A
                </div>
              </div>

              <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl">
                Hesaba <span className="bg-gradient-to-r from-indigo-400 to-violet-400 bg-clip-text text-transparent">daxil olun</span>
              </h1>

              <p className="mx-auto mt-3 max-w-sm text-sm leading-6 text-slate-400 sm:text-base">
                Hesabınıza daxil olmaq üçün məlumatlarınızı aşağıdakı
                sahələrə daxil edin.
              </p>
            </div>

            {/* ========================================================
                FORM HİSSƏSİ
            ======================================================== */}
            <div className="px-6 pb-7 sm:px-8 sm:pb-9">
              {/* VALIDASİYA XƏTASI */}
              {validationMessage && (
                <div className="mb-5 flex items-start gap-3 rounded-2xl border border-amber-400/20 bg-amber-500/10 p-4 text-amber-200">
                  <IoAlertCircleOutline className="mt-0.5 shrink-0 text-xl" />

                  <div>
                    <p className="text-sm font-bold">
                      Məlumatları yoxlayın
                    </p>

                    <p className="mt-1 text-xs leading-5 text-amber-200/80">
                      {validationMessage}
                    </p>
                  </div>
                </div>
              )}

              {/* SERVER XƏTASI */}
              {errorMessage && (
                <div className="mb-5 rounded-2xl border border-red-400/20 bg-red-500/10 p-4 text-red-200">
                  <div className="flex items-start gap-3">
                    <IoAlertCircleOutline className="mt-0.5 shrink-0 text-xl" />

                    <div className="min-w-0">
                      <p className="text-sm font-bold">
                        Giriş mümkün olmadı
                      </p>

                      <p className="mt-1 text-xs leading-5 text-red-200/80">
                        {errorMessage}
                      </p>
                    </div>
                  </div>

                  <div className="mt-3 flex items-center gap-2 border-t border-red-300/10 pt-3 text-xs text-red-200/60">
                    <IoRefreshOutline />

                    <span>
                      Məlumatlarınızı yoxlayın və yenidən cəhd edin.
                    </span>
                  </div>
                </div>
              )}

              {/* UĞURLU GİRİŞ */}
              {successMessage && (
                <div className="mb-5 flex items-start gap-3 rounded-2xl border border-emerald-400/20 bg-emerald-500/10 p-4 text-emerald-200">
                  <IoCheckmarkCircleOutline className="mt-0.5 shrink-0 text-xl" />

                  <div>
                    <p className="text-sm font-bold">
                      Əməliyyat uğurla tamamlandı
                    </p>

                    <p className="mt-1 text-xs leading-5 text-emerald-200/80">
                      {successMessage}
                    </p>
                  </div>
                </div>
              )}

              <form onSubmit={handleLogin} className="space-y-5">
                {/* ====================================================
                    E-POÇT / DƏVƏT KODU
                ==================================================== */}
                <div>
                  <label
                    htmlFor="loginId"
                    className="mb-2 block text-sm font-semibold text-slate-200"
                  >
                    E-poçt ünvanı və ya dəvət kodu
                    <span className="ml-1 text-red-400">*</span>
                  </label>

                  <div className="group relative">
                    <IoMailOutline className="absolute left-4 top-1/2 z-10 -translate-y-1/2 text-xl text-slate-500 transition group-focus-within:text-indigo-400" />

                    <input
                      type="text"
                      id="loginId"
                      placeholder="E-poçt və ya dəvət kodunu daxil edin"
                      value={email}
                      onChange={(e) => {
                        const value = e.target.value;

                        setEmail(value);
                        setReferralCode(value);

                        if (validationMessage) {
                          setValidationMessage("");
                        }

                        if (errorMessage) {
                          setErrorMessage("");
                        }
                      }}
                      required
                      autoComplete="username"
                      disabled={isLoading}
                      className="w-full rounded-2xl border border-white/10 bg-slate-950/70 py-3.5 pl-12 pr-4 text-sm text-white outline-none transition-all placeholder:text-slate-600 hover:border-white/20 focus:border-indigo-500/70 focus:bg-slate-950 focus:ring-4 focus:ring-indigo-500/10 disabled:cursor-not-allowed disabled:opacity-60 sm:text-base"
                    />
                  </div>

                  <p className="mt-2 px-1 text-xs text-slate-500">
                    Hesabınıza e-poçt ünvanınız və ya dəvət kodunuzla daxil ola bilərsiniz.
                  </p>
                </div>

                {/* ====================================================
                    ŞİFRƏ
                ==================================================== */}
                <div>
                  <label
                    htmlFor="password"
                    className="mb-2 block text-sm font-semibold text-slate-200"
                  >
                    Şifrə
                    <span className="ml-1 text-red-400">*</span>
                  </label>

                  <div className="group relative">
                    <IoLockClosedOutline className="absolute left-4 top-1/2 z-10 -translate-y-1/2 text-xl text-slate-500 transition group-focus-within:text-indigo-400" />

                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      id="password"
                      placeholder="Şifrənizi daxil edin"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);

                        if (validationMessage) {
                          setValidationMessage("");
                        }

                        if (errorMessage) {
                          setErrorMessage("");
                        }
                      }}
                      required
                      autoComplete="current-password"
                      disabled={isLoading}
                      className="w-full rounded-2xl border border-white/10 bg-slate-950/70 py-3.5 pl-12 pr-12 text-sm text-white outline-none transition-all placeholder:text-slate-600 hover:border-white/20 focus:border-indigo-500/70 focus:bg-slate-950 focus:ring-4 focus:ring-indigo-500/10 disabled:cursor-not-allowed disabled:opacity-60 sm:text-base"
                    />

                    <button
                      type="button"
                      onClick={() =>
                        setIsPasswordVisible((prev) => !prev)
                      }
                      disabled={isLoading}
                      aria-label={
                        isPasswordVisible
                          ? "Şifrəni gizlət"
                          : "Şifrəni göstər"
                      }
                      className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-xl text-slate-500 transition hover:bg-white/5 hover:text-indigo-400 disabled:cursor-not-allowed"
                    >
                      {isPasswordVisible ? (
                        <IoEyeOffOutline className="text-xl" />
                      ) : (
                        <IoEyeOutline className="text-xl" />
                      )}
                    </button>
                  </div>
                </div>

                {/* ====================================================
                    GİRİŞ DÜYMƏSİ
                ==================================================== */}
                <button
                  type="submit"
                  disabled={isLoading}
                  className="group relative flex w-full items-center justify-center gap-3 overflow-hidden rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-600 px-5 py-4 text-sm font-bold text-white shadow-xl shadow-indigo-600/20 transition-all duration-300 hover:-translate-y-0.5 hover:from-indigo-500 hover:to-violet-500 hover:shadow-2xl hover:shadow-indigo-600/30 active:translate-y-0 disabled:cursor-not-allowed disabled:from-slate-700 disabled:to-slate-700 disabled:shadow-none"
                >
                  <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform duration-700 group-hover:translate-x-full" />

                  {isLoading ? (
                    <>
                      <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/30 border-t-white" />

                      <span>Hesaba daxil olunur...</span>
                    </>
                  ) : (
                    <>
                      <span>Hesaba daxil ol</span>

                      <IoArrowForwardOutline className="text-xl transition-transform group-hover:translate-x-1" />
                    </>
                  )}
                </button>

                {/* YÜKLƏNMƏ VƏZİYYƏTİ HAQQINDA MƏLUMAT */}
                {isLoading && (
                  <div className="rounded-2xl border border-indigo-400/10 bg-indigo-500/5 px-4 py-3 text-center">
                    <p className="text-xs text-indigo-200/80">
                      Giriş məlumatları yoxlanılır. Zəhmət olmasa, gözləyin...
                    </p>
                  </div>
                )}
              </form>

              {/* ========================================================
                  QEYDİYYAT
              ======================================================== */}
              <div className="my-7 flex items-center gap-3">
                <div className="h-px flex-1 bg-white/10" />

                <span className="text-xs text-slate-600">
                  və ya
                </span>

                <div className="h-px flex-1 bg-white/10" />
              </div>

              <div className="rounded-2xl border border-white/5 bg-white/[0.02] p-4 text-center">
                <p className="text-sm text-slate-400">
                  Hələ hesabınız yoxdur?
                </p>

                <button
                  type="button"
                  onClick={handleRegister}
                  disabled={isLoading}
                  className="mt-2 font-bold text-indigo-400 transition hover:text-violet-400 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  Yeni hesab yaradın
                </button>
              </div>

              {/* ========================================================
                  ANA SƏHİFƏ
              ======================================================== */}
              <button
                type="button"
                onClick={handleHome}
                disabled={isLoading}
                className="mt-5 flex w-full items-center justify-center gap-2 rounded-2xl border border-white/10 bg-white/[0.02] px-4 py-3 text-sm font-semibold text-slate-400 transition hover:border-indigo-400/20 hover:bg-white/[0.04] hover:text-white disabled:cursor-not-allowed disabled:opacity-50"
              >
                <IoArrowForwardOutline className="rotate-180" />

                Ana səhifəyə qayıt
              </button>
            </div>
          </div>

          {/* ============================================================
              ALT MƏLUMAT
          ============================================================ */}
          <p className="mt-5 text-center text-xs text-slate-600">
            Hesabınıza təhlükəsiz şəkildə daxil olun.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Login;

